import Carousel from 'stimulus-carousel';

export default class extends Carousel {
    static values = {
        autoplay: String,
        space: String
    }

    connect() {
        if (window.innerWidth <= 920) {
            super.connect()
            this.preheat()
        }
    }

    resize() {
        if (window.innerWidth <= 920) {
            if (!this.swiper || this.swiper.destroyed) {
                this.connect()
            }
        }
        else {
            if (this.swiper && !this.swiper.destroyed) {
                this.swiper.destroy()
            }
        }
    }

    preheat() {
        this.swiper.pagination.bullets[0].classList.remove('swiper-pagination-bullet-active')
        setTimeout(() => {
            this.swiper.pagination.bullets[0].classList.add('swiper-pagination-bullet-active')
        })
    }

    // You can set default options in this getter.
    get defaultOptions() {
        const overide = {
            watchOverflow: true,
            spaceBetween: 10,
            breakpoints: {},
            pagination: {
                el: '.post-list__pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="${className}" tabindex="${index}"><span class="swiper-custom-btn post-list__page-progress"></span></span>`;
                },
            },
        }
        if (this.hasAutoplayValue) {
            overide.autoplay = {
                delay: this.autoplayValue,
                disableOnInteraction: false
            }
            overide.pagination.renderBullet = (index, className) => {
                return `<span class="${className}" tabindex="${index}"><span class="swiper-custom-btn post-list__page-progress" style="transition-duration: ${this.autoplayValue}ms"></span></span>`;
            }
        }
        return overide
    }
}

// export default class extends Controller {
//
// }
// document.addEventListener( 'DOMContentLoaded', () => {
//     const swiper = new Swiper('.post-list__slider', {
//         watchOverflow: true,
//         effect: 'fade',
//         spaceBetween: 10,
//         breakpoints: {
//
//         },
//         pagination: {
//             el: '.post-list__pagination',
//             clickable: true,
//             renderBullet: function (index, className) {
//                 return `<span class="${className}" tabindex="${index}"><span class="swiper-custom-btn"></span></span>`;
//             },
//         },
//         // autoplay: {
//         //     delay: 5000,
//         //     disableOnInteraction: false
//         // }
//     })
//     swiper.pagination.bullets[0].classList.remove('swiper-pagination-bullet-active')
//     setTimeout(() => {
//         swiper.pagination.bullets[0].classList.add('swiper-pagination-bullet-active')
//     })
//     console.log(swiper)
// }, false )
